import {
  lang
} from './_utils.js';

import TypeIt from "typeit";



function starType(params) {
  const isDesktopLogo = window.innerWidth > 767 ? true : false;
  new TypeIt( isDesktopLogo ? ".typeit" : '.typeit_mobile', {
    speed: 160,
    startDelete: true,
    startDelay: 2000,
    cursor: false,
    lifeLike: true,
    loop: true,
    loopDelay: 0
  })
    .type("ENTWICKLUNG", {delay: 1500})
    .delete(null, {delay: 200})
    .type("SEO & SEA", {delay: 2500})
    .delete(null, {delay: 200})
    .type(lang === 'de' ? "DATENSCHUTZ" : "DATA PROTECTION" , {delay: 2500})
    .delete(null, {delay: 200})
    .type("TRACKING", {delay: 2500})
    .delete(null, {delay: 200})
    .type("WEBDESIGN", {delay: 3000})
    .delete(null, {delay: 0})
    .go();
}


if ( document.querySelector('.typeit') !== null ) {
  starType();
}

